import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
import { postSMSSetup } from '../../apis/settings.api';
import { useGlobalStateContext } from '../GlobalStateContext/GlobalStateContext';
//Defining initial state
export const initialState = {
    apiReply: {
        success: false,
        reason: '',
    },
    smsSetupCurrentStep: 0,
};
export const SmsSetupContext = createContext(undefined);
// Creating a custom hook to access the context
export function useSmsSetupContext() {
    const context = useContext(SmsSetupContext);
    if (!context) {
        throw new Error('useSmsSetupContext must be used within an SmsSetupContext Provider');
    }
    return context;
}
// Creating a provider component
export const SmsSetupContextProvider = ({ children }) => {
    const [smsSetupContextState, setSmsSetupContextState] = useState(initialState);
    const { globalState: { merchant }, } = useGlobalStateContext();
    const smsAPIEndPoint = ['/user/postotp', '/user/verifyotp'];
    const handleSmsSetup = async (smsSetupPayload, step, goToNextStep = true) => {
        if (!merchant || !merchant.number || merchant.number === 0 || merchant.number === null) {
            return;
        }
        try {
            const res = await postSMSSetup({
                merchantNum: merchant?.number,
                ...smsSetupPayload,
            }, smsAPIEndPoint[step]);
            const response = res;
            if (response instanceof Error) {
                setSmsSetupContextState((prevState) => ({
                    ...prevState,
                    apiReply: {
                        success: false,
                        reason: response.message,
                        failureCode: response.response.status,
                    },
                }));
            }
            else {
                const { success, reason, failureCode } = response || {};
                setSmsSetupContextState((prevState) => ({
                    ...prevState,
                    apiReply: {
                        success,
                        reason,
                        failureCode,
                    },
                    ...(success && goToNextStep && { smsSetupCurrentStep: step + 2 }),
                }));
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    const contextValue = {
        smsSetupContextState,
        setSmsSetupContextState,
        handleSmsSetup,
    };
    return _jsx(SmsSetupContext.Provider, { value: contextValue, children: children });
};
